// deps
import Router from "next/router";
import { useEffect } from "react";
import { useIntl } from "react-intl";

// hooks
import useAuthAs from "@raiden/library/hooks/auth/as";
import Seo from "../../components/Seo";

// containers
import { USERS_USER_TYPE_VALUE_CUSTOMER } from "@raiden/library/constants/users";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import AuthLanding from "../../containers/Auth/Landing";
import useRouterNumber from "@raiden/library/hooks/router/useRouterNumber";
import { WIZARD_SUBSCRIPTIONS_SESSIONS_STORAGE_KEY_PRESTATION_ID } from "../../containers/Wizard";

export default function Page() {
  const intl = useIntl();

  const { logged, loading, user } = useAuthAs();

  const prestationId = useRouterNumber("prestationId");

  useEffect(() => {
    if (prestationId !== undefined) {
      sessionStorage.setItem(
        WIZARD_SUBSCRIPTIONS_SESSIONS_STORAGE_KEY_PRESTATION_ID,
        prestationId.toString(),
      );
    }
  }, [prestationId]);

  useEffect(
    function () {
      if (!loading && logged) {
        if (user?.user_type === USERS_USER_TYPE_VALUE_CUSTOMER) {
          let redirect = Router.query?.next?.toString?.();
          if (redirect) {
            redirect = redirect.replace(
              // @ts-ignore
              process.env.NEXT_PUBLIC_FRONT_BASE_PATH_CONFIG,
              "",
            );
            if (!redirect.startsWith("/")) {
              redirect = undefined;
            }
          }
          Router.push(
            redirect ?? generateFrontPath({ id: "@account.dashboard" }),
          );
        }
      }
    },
    [logged, loading, user],
  );

  return (
    <>
      <Seo
        title={intl.formatMessage({
          defaultMessage: "Espace client",
        })}
        description={intl.formatMessage({
          defaultMessage: "Inscrivez-vous ou connectez-vous à votre compte.",
        })}
      />

      <AuthLanding />
    </>
  );
}

Page.getInitialProps = async function () {
  return {
    layout: "signedOut",
  };
};
